export default __webpack_public_path__ + "static/media/home-line.ad18ec1c.svg";